// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39fwc","label":"styles_label__ijEbX"};